import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, forkJoin } from 'rxjs';
import { UrlBuilderService } from '../../common/services/url-builder.service';
import { InvoiceLoggingAndSuggestedCodingDto, GetInvoiceLoggingAndSuggestedCodingResponse, InvoiceLoggingAndSuggestedCoding, SaveInvoiceLoggingAndSuggestedCodingResponse, SaveInvoiceLoggingAndSuggestedCodingRequest } from '@admin/models/system-configuration-model';
import { map } from 'rxjs';
import { TransactionTypeHttpService } from './transaction-type-http.service';

@Injectable({ providedIn: 'root' })
export class SuggestedCodingHttpService {

  constructor(
    private http: HttpClient,
    private urlBuilder: UrlBuilderService,
    private readonly transactionTypeService: TransactionTypeHttpService) { }

  getInvoiceLoggingAndSuggestedCoding(): Observable<InvoiceLoggingAndSuggestedCoding> {
    const getSuggestedCodingConfig = this.http.get<GetInvoiceLoggingAndSuggestedCodingResponse>(this.urlBuilder.getUrl(`suggested_coding`))
    const getTransactionTypes = this.transactionTypeService.GetTransactionTypes();
    return forkJoin(
      getSuggestedCodingConfig,
      getTransactionTypes
    ).pipe(
      map(([suggestedCodingRes, transactionTypes]) => {
        const result = {
          ...suggestedCodingRes.InvoiceLoggingAndSuggestedCodingDto,
          DefaultCreditorInvoiceDocumentTypeCode: transactionTypes.find(x => x.Code == suggestedCodingRes.InvoiceLoggingAndSuggestedCodingDto.DefaultCreditorInvoiceDocumentTypeCode),
        };
        return result as InvoiceLoggingAndSuggestedCoding;
      }));
  }

  saveInvoiceLoggingAndSuggestedCoding(config: InvoiceLoggingAndSuggestedCoding): Observable<boolean> {
    const saveRequest: SaveInvoiceLoggingAndSuggestedCodingRequest = {
      InvoiceLoggingAndSuggestedCodingDto: {
        ...config,
        DefaultCreditorInvoiceDocumentTypeCode: config.DefaultCreditorInvoiceDocumentTypeCode.Code
      }
    };
    const url = this.urlBuilder.getUrl(`suggested_coding`);
    return this.http.post<SaveInvoiceLoggingAndSuggestedCodingResponse>(url, saveRequest).pipe(
      map(res => {
        if (res.Success) {
          return true;
        } else {
          console.error(JSON.stringify(res));
          return false;
        }
      })
    );
  }

  refreshInvoiceSuggestedCodingResponse(): Observable<boolean> {
    const url = this.urlBuilder.getUrl(`suggested_coding/refresh`);
    return this.http.get(url).pipe(
      map(res => true)
    );
  }
}
